



































































































































import { IOrderTotalSummaryViewModel } from "@/chipply/view-model/IOrderTotalSummaryViewModel";
import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";
import { IEcertBalanceInfo, IOrderTotals, Utils } from "chipply-common";
import PriceDisplay from "./PriceDisplay.vue";
import Decimal from "decimal.js";
import AppliedCodeChip from "../AppliedCodeChip.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: { PriceDisplay, AppliedCodeChip },
})
export default class OrderTotalSummary extends Vue {
    public name = "OrderTotalSummary";

    @Prop({ type: Object })
    public vm!: IOrderTotalSummaryViewModel;

    @Prop({ type: Boolean })
    public bold!: boolean;

    @Prop({ type: Object })
    public totals!: IOrderTotals;

    @Prop({ type: Boolean, default: false })
    public isEstimate!: boolean;

    @Prop({ type: Number })
    public itemTotal!: number;

    @Inject()
    private priceDisplay!: IPriceDisplay;

    public valueDisplayFunc = (priceArgs: number) => Utils.getCurrencyValue(priceArgs, false, true);

    public getEcertDisplay(ecert: IEcertBalanceInfo) {
        const display =
            ecert.displayType == 0
                ? this.valueDisplayFunc(ecert.availableBalance)
                : Math.round((ecert.availableBalance * 100) / this.priceDisplay.dollarValuePerPoint) / 100 + "pts";
        return `(balance: ${display})`;
    }

    public get subtotalTitle() {
        return "Subtotal";
    }

    public get totalTitle() {
        if (this.vm.isReadonly) {
            return "Total Paid";
        }

        return this.isEstimate ? "Estimated Total" : "Total";
    }

    public get totalDue() {
        if (!this.totals) {
            return 0;
        }
        const result = new Decimal(this.totals.orderTotal).minus(this.totals.ecertTotal).minus(this.totals.couponTotal);
        return result.toNumber();
    }

    public emitApplyCode() {
        this.$emit("applyCode");
    }
}
